import * as THREE from 'three';
import Overlays from 'demo/scenes/Overlays';
import AlphaScene from 'demo/scenes/AlphaScene';
import { DEMO_LENGTH, ROW_RATE } from './config';
import 'demo/styles/styles.scss';

// dom elements
const app = document.getElementById('app');
const demo = document.getElementById('demo');
let demoStarted = false;
let startTime;

// init audio
const audio = new Audio();
audio.src = "demo.mp3";
// audio.volume = 0;
audio.load();

audio.addEventListener('canplay', () => {
  console.log('Audio: [ready]');
  app.className = "ready";
});

// TODO: Move to click handler
// audio analyzer
let audioBufferData;
let analyser;
const initAudioContext = () => {
  const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  analyser = audioCtx.createAnalyser();
  analyser.fftSize = 2048;
  const mediaSource = audioCtx.createMediaElementSource(audio);
  mediaSource.connect(analyser);
  const gainNode = audioCtx.createGain();
  gainNode.value = 1;
  mediaSource.connect(gainNode);
  gainNode.connect(audioCtx.destination);
  const bufferLength = analyser.frequencyBinCount;
  audioBufferData = new Uint8Array(bufferLength);
};

// init renderer
const renderer = new THREE.WebGLRenderer({
  antialias: true
});
renderer.setSize(window.innerWidth, window.innerHeight);
renderer.setClearColor(new THREE.Color(0));
demo.appendChild(renderer.domElement);

// listen to window resize
window.addEventListener('resize', function () {
  demo.style.width = `${window.innerWidth}px`
  demo.style.height = `${window.innerHeight}px`
  renderer.setSize(window.innerWidth, window.innerHeight);
});

// init rocket
const syncDevice = new JSRocket.SyncDevice();
syncDevice.setConfig({ rocketXML: 'omega.rocket' });
let row = 0;

syncDevice.init('demo');

syncDevice.on('ready', () => {
  console.log('Rocket: [ready]');
});

syncDevice.on('update', (newRow) => {
  row = newRow;
  console.log('Rocket: [update] row', row);
  audio.currentTime = Math.max(0, Math.round(row / ROW_RATE));
});

syncDevice.on('play', () => {
  console.log("Rocket: [play] time in seconds", row / ROW_RATE);

  if (activeScene) {
    activeScene.setPaused(false);
  }

  audio.play();

  if (!demoStarted) {
    startDemo();
  }
});

syncDevice.on('pause', () => {
  console.log("Rocket [pause] time in seconds", row / ROW_RATE);
  audio.pause();

  if (activeScene) {
    activeScene.setPaused(true);
  }
});

// init scene
let activeScene;
let overlays;

/**
 * Render loop
 */
const render = (t) => {
  window.requestAnimationFrame(render);
  const timeDelta = t - startTime;
  // update sync position
  if (!audio.paused) {
    row = Math.round(audio.currentTime * ROW_RATE);
  }
  syncDevice.update(row);

  // get audio data
  analyser.getByteTimeDomainData(audioBufferData);

  // render scene(s)
  if (row < DEMO_LENGTH) {
    activeScene.render(row, audioBufferData);
  } else {
    renderer.clear(0x000000);
  }

  overlays.render(row);
};

/**
 * Start demo
 */
const startDemo = () => {
  console.log('Demo: [start]');

  if (!__DEV__) {
    if (demo.requestFullscreen) {
      demo.requestFullscreen();
    } else if (demo.msRequestFullscreen) {
      demo.msRequestFullscreen();
    } else if (demo.mozRequestFullScreen) {
      demo.mozRequestFullScreen();
    } else if (demo.webkitRequestFullscreen) {
      demo.webkitRequestFullscreen();
    }
  }

  app.className = 'demo';
  demoStarted = true;
  activeScene = new AlphaScene(renderer, syncDevice);
  overlays = new Overlays(syncDevice);
  row = 0;
  syncDevice.update(0);
  initAudioContext();
  audio.play();
  startTime = performance.now();
  render(startTime);
};

document.getElementById('splash').addEventListener('click', () => {
  startDemo();
});
